<template>
  <div class="qrcode-wrapper">
    <canvas ref="qrcodeCanvas" width="136" height="136"></canvas>
    <i class="logo"></i>
  </div>
</template>
<script lang="ts" setup>
import QRCode from 'qrcode'
import { onMounted, ref, watch } from 'vue'
import { getShortUrl } from '../getCommonReaderAjaxInfo'
import { getDDLUrl } from '../../utils/index'
import { getCookie } from '@share/utils/index'
import { getCurrentPidFromDOM, getCurrentTrace } from '@share/common/track'
const props = defineProps({
  chapterId: {
    type: String,
    default: '0',
  },
  bookId: {
    type: Number,
    default: 0,
  },
  width: {
    type: Number,
    default: 136,
  },
  margin: {
    type: Number,
    default: 1,
  },
  show: {
    type: Boolean,
    default: false,
  },
  dlTrack: {
    type: String,
    default: '',
  },
  actionMethod: {
    type: String,
    default: 'openChapter',
  },
})
const curQrCodeCache = ref(new Map())
const getSettingQrcodeText = () => {
  const { bookId, chapterId } = props
  if (!chapterId && !bookId) {
    return
  }
  // 33481814400000 未来100年时间戳为了兼容ddl的currenttime
  const currentUuid = getCookie('newstatisticUUID')
  // 归因 trace：cookie 优先；其次取当前页 pid（与 trace 同形态）；
  // 最终兜底矩阵站 v2 统一来源标识，保证 PC 端下载 App 二维码的归因数据始终携带来源
  const trace = getCookie('_trace') || getCurrentTrace()
  // 当前页 pid：从 SSR 注入的 data-pid 取（新格式 qdmatrixv2_{site}_{page}），
  // 兜底使用旧 'qd_P_read'，保证未挂载或离开阅读页时归因报文仍有可用占位
  const currentPid = getCurrentPidFromDOM() || 'qd_P_read'
  const pcParam = [
    currentUuid,
    currentPid,
    bookId,
    chapterId,
    '',
    33481814400000,
    props.dlTrack,
    trace,
  ]
  const readNavMobileOptions = {
    method: props.actionMethod,
    query: JSON.stringify({
      _report: 'qidian_pc',
      _pc: pcParam.join('$'),
      bookId,
      chapterId: `${chapterId}`,
    }),
    uuid: currentUuid,
  }
  const url = getDDLUrl(readNavMobileOptions)
  getShortUrl(url).then((data) => {
    const text = `https://qdd.gg/t1/${data}`
    curQrCodeCache.value.set(
      `${props.bookId}_${props.chapterId}_${props.dlTrack}`,
      text,
    )
    generateQR(text)
  })
}
const qrcodeCanvas = ref()
const generateQR = async (text: string) => {
  try {
    await QRCode.toCanvas(qrcodeCanvas.value, text, {
      width: props.width,
      margin: props.margin,
    })
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err)
  }
}
onMounted(() => {
  generateQR('https://qdd.gg/6MMTDZJf')
})
watch([() => props.show], (value) => {
  if (value[0]) {
    const curCacheQrcode = curQrCodeCache.value.get(
      `${props.bookId}_${props.chapterId}_${props.dlTrack}`,
    )
    if (curCacheQrcode) {
      generateQR(curCacheQrcode)
    } else {
      getSettingQrcodeText()
    }
  }
})
</script>
<style scoped lang="scss">
.qrcode-wrapper {
  position: relative;
  display: inline-block;
  .logo {
    width: 28px;
    height: 28px;
    background: url(https://imgservices-1252317822.image.myqcloud.com/coco/s11022022/43dddf20.il61if.svg)
      no-repeat center/100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
